var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcalIconPurpleLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.8 48",
    style: {
      enableBackground: "new 0 0 47.8 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#A324AD;}\n\t.st2{fill:#F28C00;}\n\t.st3{fill:#EE7624;}\n\t.st4{fill:#009BE0;}\n\t.st5{fill:#01BFD7;}\n\t.st6{fill:#F9BF01;}\n\t.st7{fill:#76BD22;}\n\t.st8{fill:#00A8E2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.9,
    cy: 24.1,
    r: 23.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.9,1.2c12.6,0,22.9,10.3,22.9,22.9S36.5,47,23.9,47S1,36.7,1,24.1S11.3,1.2,23.9,1.2 M23.9,0.2 C10.7,0.2,0,10.9,0,24.1S10.7,48,23.9,48s23.9-10.7,23.9-23.9S37.1,0.2,23.9,0.2L23.9,0.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.8,17.4h-6.5c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1h6.5 c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.2-0.1-0.4 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2C23.1,17.4,22.9,17.4,22.8,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.9,14.5H18.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.1,0.4s0,0.2,0.1,0.4s0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1h16.6 c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.3-0.6C35.4,14.6,35.2,14.5,34.9,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.4,31.7H18.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.1,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1h13.1 c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.5-0.3-0.6C31.9,31.8,31.7,31.7,31.4,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.6,25.9H16c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.3,0.6,0.3h6.6c0.1,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.4 c0-0.1,0-0.2-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3C23.2,26.1,23.1,26,23,26C22.8,25.9,22.7,25.9,22.6,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M24.3,20.2H11.7c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 h12.6c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7S24.6,20.2,24.3,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28.7,23.1H18.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c-0.1,0.1-0.1,0.2-0.1,0.4s0,0.2,0.1,0.4s0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1h10.4c0.1,0,0.3,0,0.4-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.4s0-0.2-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3 c-0.1-0.1-0.2-0.2-0.3-0.2C29,23.1,28.9,23.1,28.7,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M20.4,28.8H9.8c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3 h10.6c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.3-0.6C20.8,28.9,20.6,28.8,20.4,28.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcalIconPurpleLight);
export default __webpack_public_path__ + "static/media/ecal_icon_purple_light.7474626245f1a809c7662eda66a42913.svg";
export { ForwardRef as ReactComponent };